<template>
  <div>
    <sHeader :activeIndex="2" />
    <div class="page-content">
      <SubCategory :categoryType="categoryType" :categories="categories" />
    </div>
  </div>
</template>

<script>
import sHeader from '@/components/templates/sHeader'
import SubCategory from '@/components/templates/SubCategory'

export default {
  components: {
    sHeader,
    SubCategory
  },
  methods: {
  },
  data () {
    return {
      categoryType: 'story',
      categories: [
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/eejiin_ulger.png',
          title: 'bbb',
          // route: '/Story/bbb'
          // categoryType: 'Story',
          id: '25'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/gaihamshigt_kinuu.png',
          title: '电影',
          // route: '/Story/aaa'
          // categoryType: 'Story',
          id: '11'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/ulamjilalt_jang_dadgal.png',
          title: 'aaa',
          // route: '/Story/aaa'
          // categoryType: 'Story',
          id: '26'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/jangar.png',
          title: 'aaa',
          // route: '/Story/aaa'
          // categoryType: 'Story',
          id: '28'
        },
        {
          image: '//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/bontgor_huuiin_aylal.png',
          title: 'aaa',
          // route: '/Story/aaa'
          // categoryType: 'Story',
          id: '27'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Story.vue